import { Component, OnInit, ViewChild } from '@angular/core';
import { CuentasService, CUENTA_TYPE_CLIENTE, CUENTA_TYPE_PROSPECTO, CUENTA_TYPE_PROVEEDOR } from '../../../services';
import { MdDialogRef } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AcopioAutocompleteComponent, EtiquetaAutocompleteComponent } from '../../../components/common/autocomplete';
import { regExpValidator } from '../../../utils/validators/CustomValidators';
import { SpinnerService } from '../../../services/spinner-service';
import {
  PATH_CUENTA_DETAIL,
} from '../../../navigation/navigation.module';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Component({
  selector: 'app-new-cuenta-dialog',
  templateUrl: './new-cuenta-dialog.component.html',
  styleUrls: ['./new-cuenta-dialog.component.scss']
})
export class NewCuentaDialogComponent implements OnInit {

  public cuenta;

  public title: string;
  public positiveText: string;
  public negativeText: string;

  public acopios: any = [];
  public type: number = CUENTA_TYPE_PROSPECTO;

  public showContact: boolean = false;

  public nameToggle = false;
  public nameList = [];
  public cuitList = [];
  public nameExactMatch = false;
  public cuitDuplicated = false;
  public nameCuitValid = true;
  public haveAccessToCuenta: boolean = true;

  CUENTA_TYPE_CLIENTE = CUENTA_TYPE_CLIENTE;
  CUENTA_TYPE_PROSPECTO = CUENTA_TYPE_PROSPECTO;
  CUENTA_TYPE_PROVEEDOR = CUENTA_TYPE_PROVEEDOR;

  _formBuilder: FormBuilder;
  mainForm: FormGroup;
  contactGroup: FormGroup;

  @ViewChild(AcopioAutocompleteComponent) acopioAutocompleteComponent;

  constructor(private cuentasService: CuentasService,
              public dialogRef: MdDialogRef<NewCuentaDialogComponent>,
              public formBuilder: FormBuilder,
              private spinnerService: SpinnerService,
              private router: Router,) {

    const cuitRE = /^[0-9]{11}$/;

    this._formBuilder = formBuilder;

    this.mainForm = this._formBuilder.group({
      'cuit': new FormControl('', [Validators.required, regExpValidator(cuitRE)]),
      'companyName': new FormControl('', [Validators.required]),
      'address': new FormControl(),
      'addressNumber': new FormControl(),
      'acopioAutocomplete': new FormControl()
    },{
      validator: this.submitValidator.bind(this)
    });
  }

  ngOnInit() {
    this.spinnerService.setShowFlag(false);
    let { cuenta } = this;

    if (cuenta){
      this.acopios = cuenta.Acopios;
      this.type = cuenta.ClientTypeId;

      this.mainForm.controls['cuit'].setValue(cuenta.Cuit);
      this.mainForm.controls['companyName'].setValue(cuenta.FullName);
      this.mainForm.controls['address'].setValue(cuenta.Domicilio);
      this.mainForm.controls['addressNumber'].setValue(cuenta.DomicilioNumero);
      this.checkCuenta('Name');
      this.checkCuenta('Cuit');
    }  else {
      this.type = CUENTA_TYPE_PROSPECTO;
    }

    this.setCuentaCheck();

  }

  onSubmit(){
    this.spinnerService.setShowFlag(true);
    if (this.cuenta){
      this.cuentasService.updateCuenta(
        {
          ...this.cuenta,
          ...{
            FullName: this.mainForm.get('companyName').value,
            Domicilio: this.mainForm.get('address').value,
            DomicilioNumero: this.mainForm.get('addressNumber').value,
            Cuit: this.mainForm.get('cuit').value,
            Acopios: this.acopioAutocompleteComponent.selectedAcopios.map(a => {
              return {Id: a.Id};
            }),
            ClientTypeId: this.type
          }
        }
      ).subscribe(
        data => {
          this.spinnerService.setShowFlag(false);
          this.dialogRef.close(data);
        });
    } else {
      this.cuentasService.createCuenta(
        this.mainForm.get('companyName').value,
        this.mainForm.get('address').value,
        this.mainForm.get('addressNumber').value,
        this.mainForm.get('cuit').value,
        this.acopioAutocompleteComponent.selectedAcopios.map(a => {
          return {Id: a.Id};
        }),
        [],
        this.showContact ? {
          FullName: this.contactGroup.get('contactFullName').value,
          Email: this.contactGroup.get('contactEmail').value,
          Telefono: this.contactGroup.get('contactPhoneNumber').value,
          Movil: this.contactGroup.get('contactCellphoneNumber').value,
          Domicilio: this.contactGroup.get('contactAddress').value,
          Puesto: this.contactGroup.get('contactRole').value
        } : null,
        this.type
      ).subscribe(
        data => {
          this.spinnerService.setShowFlag(false);
          this.dialogRef.close(true);
        });
    }
  }

  submitValidator(group: FormGroup){
    let validatorResult = this.contactValidator(this.contactGroup);
    let validContact = this.showContact && (validatorResult != null);

    if ((!this.acopioAutocompleteComponent || this.acopioAutocompleteComponent.selectedAcopios.length === 0)) {
      return {
        error: true
      };
    }
    return null;
  }

  contactValidator(group: FormGroup){
    if(this.showContact && this.mainForm.controls.contactGroup && this.mainForm.controls.contactGroup.invalid){
      return {
        contactFormInvalid: true
      };
    }

    return null;
  }

  showContactClicked(value){
    // TODO: asignar las expresiones regulares en un único lugar puesto que también se usan en phone-directive
    // y en email-directive
    const phoneRE = /^((\+[0-9]+)|[0-9]+)((\s[0-9])|[0-9])*$/;
    const emailRE = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{1,15})$/i;
    if(value){
      this.contactGroup = this._formBuilder.group({
        'contactFullName': new FormControl('', Validators.required),
        'contactRole': new FormControl(),
        'contactCellphoneNumber': new FormControl('', regExpValidator(phoneRE)),
        'contactPhoneNumber': new FormControl('', regExpValidator(phoneRE)),
        'contactEmail': new FormControl('', regExpValidator(emailRE)),
        'contactAddress': new FormControl()
        },{
          validator: this.contactValidator.bind(this)
      });

      this.mainForm.addControl('contactGroup', this.contactGroup);
    } else {
      setTimeout(() => this.mainForm.removeControl('contactGroup'), 100);
    }
  }

  isValidAutocomplete(input: FormControl){
    if((input.value && input.value.length > 0)){
       return {
         emptyAcopios: true
       };
    }
     return null;
  }

  get contactCellphoneNumber() {
    return this.contactGroup.get('contactCellphoneNumber');
  }
  get contactPhoneNumber() {
    return this.contactGroup.get('contactPhoneNumber');
  }
  get contactEmail() {
    return this.contactGroup.get('contactEmail');
  }
  get cuit() {
    return this.mainForm.get('cuit');
  }

  checkCuenta(control) {
    // el endpoint devuelve cuit y nombres coincidentes, pero si le enviamos valores vacios ("", 0)
    // devuelve un array con un valor de ID 0. si no encuentra coincidencias, devuelve array vacío
    // solo se verifica para el control que hizo la llamada para evitar hacer consultas innecesarias

    if (control === 'Name') {
      this.nameList = [];
      this.nameExactMatch = false;
      this.cuentasService.checkCuenta(this.mainForm.get('companyName').value, 0)
        .subscribe(resp => {
          // si el primer valor de id de nombre es 0, es por que hubo un error de input o server
          if (resp.CuentasByName.length >= 1 && resp.CuentasByName[0].Id !== 0) {
            this.nameList = resp.CuentasByName;

            // si estamos editando, quitar la cuenta que se esta editando de los resultados
            if (this.cuenta) {
              for (let i = 0; i < this.nameList.length; i++) {
                if (this.cuenta.Id === this.nameList[i].Id) {
                  this.nameList.splice(i, 1);
                  break;
                }
              }
            }

            /*const exactList = [];
            const companyName = this.mainForm.controls['companyName'].value.toString().toUpperCase();
            this.nameList.forEach(x => {
              if (x.FullName.toString().toUpperCase() === companyName) {
                this.nameExactMatch = true;
                exactList.push(x);
              }
            });
            // si hay coincidencias exactas, solo dejar las mismas en la lista
            if (this.nameExactMatch) {
              this.nameList = exactList;
            }
            this.nameToggle = false;
            this.nameCuitValidator();*/
          }
        });
    } else if (control === 'Cuit') {

      this.cuitList = [];
      this.cuitDuplicated = false;
      this.cuentasService.checkCuenta('', this.mainForm.get('cuit').value)
        .subscribe(resp => {
          if (resp.CuentasByCuit.length >= 1 && resp.CuentasByCuit[0].Id !== 0) {
            this.cuitList = resp.CuentasByCuit;

            // si estamos editando, quitar la cuenta que se esta editando de los resultados
            if (this.cuenta) {
              for (let i = 0; i < this.cuitList.length; i++) {
                if (this.cuenta.Id === this.cuitList[i].Id) {
                  this.cuitList.splice(i, 1);
                  break;
                }
              }
            }

            this.cuitDuplicated = this.cuitList.length >= 1;

            if (this.cuitDuplicated) {
              this.checkAccess(this.cuitList[0].Id);
            }

            // Aca verificar si puede entrar al CUIT
            this.nameCuitValidator();
          }
        });
    }
  }

  checkAccess(cuentaId) {
    this.cuentasService.checkUserAccess(cuentaId)
      .subscribe(value => {
        this.haveAccessToCuenta = value.ResponseData;
      }
    );
  }

  // al tipear verificar que no haya repetidos
  setCuentaCheck() {
    this.mainForm.controls['cuit'].valueChanges.debounceTime(500)
      .subscribe(value => {
        this.cuitList = [];
        this.cuitDuplicated = false;
        this.nameCuitValidator();
        if (value.toString().length === 11) {
          this.checkCuenta('Cuit');
        }
      });

    this.mainForm.controls['companyName'].valueChanges.debounceTime(500)
      .subscribe(value => {
        this.nameList = [];
        this.nameExactMatch = false;
        this.nameCuitValidator();
        if (value.length > 3) {
          this.checkCuenta('Name');
        }
      });

  }

  // mostrar u ocultar la lista de cuentas coincidentes al chequear
  toggleName() {
    this.nameToggle = !this.nameToggle;
  }

  goToCuenta(id) {
    this.router.navigate([PATH_CUENTA_DETAIL, id]);
    this.dialogRef.close(false);
  }

  nameCuitValidator() {
    this.nameCuitValid = !(/*this.nameExactMatch || */this.cuitDuplicated);
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/new-cuenta-dialog/new-cuenta-dialog.component.ts